import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    SearchParams: {},
    hotels: [],
    onceSubmit: false,
    currency: localStorage.getItem("currency") || "MOP",
    dataLayerReady: false,
    gaData: {
      transactionId: "",
      transactionTotal: "",
      transactionTax: "",
      transactionProducts: "",
      currentTimeMacau: localStorage.date || "",
      currentTimeLocal: "",
      checkInDate: "",
      checkOutDate: "",
      selectedHotel: "",
      memberLoggedIn: false,
      numberTotalRooms: "",
      numberTotalAdults: "",
      numberTotalChild: "",
      numberTotalNights: "",
      pointsUsed: "",
      paymentMethod: "",
      currentStep: "",
      cookieId: "",
      skinCode: "",
      placeOfResidence: ""
    },
    netCode: "",
    timeout: 30 * 60 * 1000,
    serverTime: "",
    pattern: /^(?![\da-z]+$)(?![\dA-Z]+$)(?![\d!#$%^&*]+$)(?![a-zA-Z]+$)(?![a-z!@#$%^&*()\-+=~?/|;:{}'",<>.]+$)(?![A-Z!@#$%^&*()\-+=~?/|;:{}'",<>.]+$)[\da-zA-z!@#$%^&*()\-+=~?/|;:{}'",<>.]{8,20}$/,
    phoneArea: [853, 86, 852],
    resetForm: {},
    employeeQuota: -1,
    employeeRate: [],
    fnfQuota: -1,
    fnfRate: [],
    username: "",
    hotel_code: "GLPH"
  },
  mutations: {
    stateChange(state, payload) {
      state[payload.k] = payload.v;
    }
  },
  getters: {
    currencyIcon: state => {
      const obj = {
        USD: "$",
        MOP: "$",
        CNY: "¥",
        HKD: "$",
        JPY: "￥",
        KRW: "₩"
      };
      return obj[state.currency];
    }
  },
  actions: {},
  modules: {}
});
